import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/(app)/admin/competitions/$id")({
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
